module.exports = __webpack_public_path__ + "img/Love_04.133ec04d.png";